import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { IconMagnify } from 'components/icons/magnify'

export const Layout = styled.div`
  --padding: 2rem;

  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  padding-block: var(--padding);

  ${mq.medium} {
    /*gap: 5rem;*/
    /*grid-template-columns: min(40rem, 40%) 1fr;*/
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 960px) {
    grid-template-columns: 1fr 2fr;
  }
  ${mq.large} {
    /*gap: 8rem;
    --padding: 4rem;*/
  }
`

export const ProfilePicture = styled.img`
  width: 100%;
  margin: 0;
  border-radius: 1rem;
  line-height: 0;
  max-height: calc(100vh - var(--header-height) - var(--padding) - 8rem);
  max-height: calc(100svh - var(--header-height) - var(--padding) - 8rem);
  object-fit: contain;
  /*background-color: currentColor;*/
`

export const Name = styled.h2`
  line-height: normal;
  margin: 0;
  margin-bottom: var(--gap);
  text-align: center;
  font-weight: bold;
`

const boxStyle = css`
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);

  ${mq.medium} {
    padding: 2em;
    border-radius: 1em;
  }
`

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  > div {
    line-height: 0;
  }
  > div:nth-child(1) {
    padding: 0;
  }
  > div:nth-child(2) {
    padding: var(--gap);
    border-radius: 2rem;
    background: white;
    box-shadow: 0px 0px 8.3px 0px rgba(26, 57, 72, 0.11);
  }

  ${mq.medium} {
    align-self: start;
  }

  ${mq.large} {
    position: sticky;
    top: 3rem;
  }
`

export const Main = styled.main``

export const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  max-width: 100%;

  ${mq.medium} {
    gap: 0;
    grid-template-columns: 1fr;
  }

  @media (min-width: 960px) {
    gap: var(--gap);
    grid-template-columns: 1fr 1fr;
  }
`

export const Dl = styled.dl`
  position: relative;
  margin: 0 0 var(--gap);
  background: white;
  box-shadow: 0px 0px 8.3px 0px rgba(26, 57, 72, 0.11);
  border-radius: 2rem;
  padding: 2rem var(--gap);

  h3 {
    font-size: 1.6rem;
    font-weight: bold;
    margin-block: 0.8em 0.4em;
  }

  dd {
    margin: 0;
  }

  ${mq.large} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const Row = styled.div`
  padding-block: 1em;
  padding: 1rem 0rem;

  br:not(:last-child) {
    margin-bottom: 0.4em;
  }
  &:first-child {
    padding-block-start: 0;
  }

  &:last-child {
    padding-block-end: 0;
  }
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: calc(100vw - 9.6rem);
    ${mq.medium} {
      max-width: calc(50vw - 10rem);
    }
    @media (min-width: 960px) {
      max-width: calc(66vw - 12rem);
    }
    @media (min-width: 1296px) {
      max-width: 74.6rem;
    }
    vertical-align: middle;
    /*transform: translateY(0.4em);*/
  }

  ${mq.ltLarge} {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;

    &:not(:first-child) {
      border-top: 1px solid #eee;
    }
  }
  dt {
    font-weight: 800;
  }
  dd {
    margin-top: 0.2em;
  }
  ${mq.large} {
    padding: 1.5rem 0rem;

    &:last-child {
      grid-column: 1 / -1;
    }

    &:nth-child(3) ~ & {
      border-top: 1px solid #b9cccc;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #b9cccc;
      margin-bottom: -1px;
    }

    dd {
      font-weight: normal;
      font-size: 2.1rem;
      line-height: 1.2;
      margin-top: 0.4em;
    }
  }
`

export const Additional = styled.div<{ $opened: boolean }>`
  br:not(:last-child) {
    margin-bottom: 0.4em;
  }
  margin: 0.4em 0 1.5rem;

  text-overflow: ellipsis;
  max-height: 4.6rem;
  line-height: 1.4;
  overflow: hidden;
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: calc(100vw - 9.6rem);
    ${mq.medium} {
      max-width: calc(50vw - 10rem);
    }
    @media (min-width: 960px) {
      max-width: calc(66vw - 12rem);
    }
    @media (min-width: 1296px) {
      max-width: 74.6rem;
    }
    vertical-align: middle;
    /*transform: translateY(0.4em);*/
  }
  ${mq.ltLarge} {
    /*${boxStyle}*/
    /*margin-top: 2rem;*/
  }

  ${mq.large} {
    font-size: 2.1rem;
    max-height: 6.2rem;
    /*margin-top: 4rem;*/
  }
  ${props =>
    props.$opened &&
    css`
      max-height: none;
      ${mq.large} {
        max-height: none;
      }
    `}

  ${mq.smallOnly} {
    max-height: none;
  }
`
export const ButtonMore = styled.div<{ $up: boolean }>`
  position: absolute;
  bottom: 1.5rem;
  right: 2rem;
  display: flex;
  justify-content: center;
  width: 75px;
  height: 19px;
  padding: 1px 10px 0px;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  font-size: 1.3rem;
  color: white;
  background: #1a3948;
  cursor: pointer;
  &:before {
    margin-bottom: 2px;
    content: '';
    display: block;
    height: 1rem;
    aspect-ratio: 1;
    mask: url("data:image/svg+xml,%3Csvg width='8' height='11' viewBox='0 0 8 11' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.21757 7.17157L4.03559 10.3536C3.84032 10.5488 3.52374 10.5488 3.32848 10.3536L0.146499 7.17157C-0.0487636 6.97631 -0.0487635 6.65973 0.146499 6.46447C0.341761 6.2692 0.658344 6.2692 0.853606 6.46447L3.18203 8.79289L3.18203 1C3.18203 0.723857 3.40589 0.5 3.68203 0.5C3.95818 0.5 4.18203 0.723857 4.18203 1L4.18203 8.79289L6.51046 6.46447C6.70572 6.2692 7.0223 6.2692 7.21757 6.46447C7.41283 6.65973 7.41283 6.97631 7.21757 7.17157Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A")
      center center / contain no-repeat;
    background-color: currentColor;
  }
  ${props =>
    props.$up &&
    css`
      &:before {
        transform: rotate(180deg);
      }
    `}
  ${mq.smallOnly} {
    display: none;
  }
`

export const SwiperContainer = styled.div`
  --swiper-theme-color: ${theme.colors.background};
  --swiper-navigation-size: 3rem;
  --swiper-navigation-sides-offset: 0;

  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: var(--gap);
  /*margin-block: var(--gap);*/
  background-color: white;
  border-radius: 2rem;
  padding: 3rem 1.5rem;
  box-shadow: 0px 0px 8.3px 0px rgba(26, 57, 72, 0.11);

  ${mq.ltLarge} {
    /*${boxStyle}*/
  }

  ${mq.large} {
    /*margin-block: var(--gap);*/
  }

  .swiper {
    width: 0;
    flex-grow: 1;
    max-width: calc(64rem + 2 * var(--swiper-navigation-size));
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    div {
      position: relative;
      margin: auto;
    }
  }

  img {
    max-width: 100%;
    border-radius: 1rem;
  }
  .swiper-button-next,
  .swiper-button-prev {
    position: relative;
    width: 2.4rem;
    height: 2.4rem;
    @media (min-width: 960px) {
      width: 4rem;
      height: 4rem;
    }
    border-radius: 2rem;
    background: var(--text-color);
    color: white;
  }
  .swiper-button-next {
    margin-left: 1.5rem;
    &:after {
      content: '';
      display: block;
      width: 1.2rem;
      height: 1.2rem;
      @media (min-width: 960px) {
        width: 2rem;
        height: 2rem;
      }
      mask: url("data:image/svg+xml,%3Csvg width='8' height='11' viewBox='0 0 8 11' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.21757 7.17157L4.03559 10.3536C3.84032 10.5488 3.52374 10.5488 3.32848 10.3536L0.146499 7.17157C-0.0487636 6.97631 -0.0487635 6.65973 0.146499 6.46447C0.341761 6.2692 0.658344 6.2692 0.853606 6.46447L3.18203 8.79289L3.18203 1C3.18203 0.723857 3.40589 0.5 3.68203 0.5C3.95818 0.5 4.18203 0.723857 4.18203 1L4.18203 8.79289L6.51046 6.46447C6.70572 6.2692 7.0223 6.2692 7.21757 6.46447C7.41283 6.65973 7.41283 6.97631 7.21757 7.17157Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A")
        center center / contain no-repeat;
      background-color: currentColor;
      transform: rotate(-90deg);
    }
  }
  .swiper-button-prev {
    margin-right: 1.5rem;
    &:after {
      content: '';
      display: block;
      width: 1.2rem;
      height: 1.2rem;
      @media (min-width: 960px) {
        width: 2rem;
        height: 2rem;
      }
      mask: url("data:image/svg+xml,%3Csvg width='8' height='11' viewBox='0 0 8 11' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.21757 7.17157L4.03559 10.3536C3.84032 10.5488 3.52374 10.5488 3.32848 10.3536L0.146499 7.17157C-0.0487636 6.97631 -0.0487635 6.65973 0.146499 6.46447C0.341761 6.2692 0.658344 6.2692 0.853606 6.46447L3.18203 8.79289L3.18203 1C3.18203 0.723857 3.40589 0.5 3.68203 0.5C3.95818 0.5 4.18203 0.723857 4.18203 1L4.18203 8.79289L6.51046 6.46447C6.70572 6.2692 7.0223 6.2692 7.21757 6.46447C7.41283 6.65973 7.41283 6.97631 7.21757 7.17157Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A")
        center center / contain no-repeat;
      background-color: currentColor;
      transform: rotate(90deg);
    }
  }
`
export const Magnify = styled(IconMagnify)`
  position: absolute;
  top: 8px;
  right: 8px;
  -webkit-filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.5));
  filter: drop-shadow(0px 0px, px rgba(0, 0, 0, 0.5));
`

export const Modal = styled.div`
  --spacing: 0rem;

  position: fixed;
  inset: 0;
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 100;

  ${mq.medium} {
    --spacing: 3rem;
  }

  ${mq.large} {
    --spacing: 5rem;
  }

  img {
    position: absolute;
    top: var(--spacing);
    left: var(--spacing);
    width: calc(100% - 2 * var(--spacing));
    height: calc(100% - 2 * var(--spacing));
    object-fit: contain;
  }
`

export const CloseButton = styled.button`
  ${styleReset}
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  color: red;
  border-radius: 50%;
  padding: 1rem;
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, 0.85);

  ${mq.medium} {
    top: 2rem;
    right: 2rem;
  }

  &::before {
    content: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 22C9.34711 22.0024 6.80218 20.9496 4.9263 19.0737C3.05042 17.1978 1.99762 14.6529 2 12V11.8C2.08179 7.79223 4.5478 4.22016 8.26637 2.72307C11.9849 1.22597 16.2381 2.0929 19.074 4.92601C21.9365 7.78609 22.7932 12.0893 21.2443 15.8276C19.6955 19.5659 16.0465 22.0024 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.41001L14.59 8.00001L12 10.59L9.41001 8.00001L8.00001 9.41001L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z' fill='currentColor'/%3E%3C/svg%3E%0A");
    display: block;
    width: 3rem;
    height: 3rem;

    ${mq.medium} {
      width: 4rem;
      height: 4rem;
    }
  }
`
